import React from 'react'
import { cn } from '@/common/lib/cn/cn'
import { Portal } from '../Portal/Portal'
import { Icon } from '../Icon/Icon'
import { Button } from '../Form/Button'
import './modal.css'

export type ModalProps = {
    color?: 'primary' | 'transparent'
    actions?: React.ReactNode
    className?: string
    container?: string | HTMLElement
    modalClassName?: string
    showCloseButton?: boolean
} & React.HTMLAttributes<HTMLDialogElement>

export const Modal = ({
    children,
    id,
    color = 'primary',
    className,
    modalClassName,
    container = 'body',
    showCloseButton = true,
    ...props
}: ModalProps) => {
    const cardClasses = cn(
        'modal',
        {
            '': color === 'primary',
            'bg-transparent': color === 'transparent',
        },
        className
    )

    React.useEffect(() => {
        if (!id) return

        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key !== 'Escape') return
            const checkbox = document.getElementById(id) as HTMLInputElement | null
            if (!checkbox?.checked) return
            checkbox.checked = false
        }

        document.addEventListener('keydown', handleKeyDown)
        return () => {
            document.removeEventListener('keydown', handleKeyDown)
        }
    }, [id])

    return (
        <Portal container={container}>
            <input type='checkbox' id={id} className='modal-toggle' />
            <dialog role='dialog' className={cardClasses} {...props}>
                <div className={cn('modal-box', modalClassName)}>
                    {showCloseButton && (
                        <Button as='label' htmlFor={id} className='modal-close' emphasis='neutral' variant='ghost'>
                            <Icon name='cross' size='lg' />
                        </Button>
                    )}
                    {children}
                </div>
                {showCloseButton && (
                    <label className='modal-backdrop' htmlFor={id}>
                        Close
                    </label>
                )}
            </dialog>
        </Portal>
    )
}
